import type { Session } from "@training/shared";

/** The screens a session is opened from, and how its way back names them. */
const ORIGINS = { "/": "Aujourd'hui", "/historique": "Journal", "/choisir": "Séances" } as const;
type Origin = keyof typeof ORIGINS;

/** What a link to a session carries, so its way back leads where it came from. */
export const fromHere = (from: Origin) => ({ from });

const isOrigin = (value: unknown): value is Origin => typeof value === "string" && value in ORIGINS;

/**
 * Where a session's "‹" leads: the screen it was opened from. Without one
 * (a reload, a link from elsewhere), a finished session belongs to the
 * journal and one under way to the choice of sessions. It always led to
 * that choice, even from the journal.
 */
export function sessionBack(state: unknown, status: Session["status"]): { to: Origin; label: string } {
  const from = (state as { from?: unknown } | null)?.from;
  const to: Origin = isOrigin(from) ? from : status === "done" ? "/historique" : "/choisir";
  return { to, label: ORIGINS[to] };
}
